import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../Providers/AuthProvider";
import { GetPackage } from "../../services/GetPackageService";
import { useFormik } from "formik";
import * as Yup from "yup";
import "animate.css";
import TrackVisibility from "react-on-screen";

import { toast } from "react-toastify";
import UpdateTourFormFourthStep from "../UpdateTourForm/UpdateTourFormFourthStep";
import { GetServicesList } from "../../services/GetServicesList";
import { DeleteServiceList } from "../../services/DeleteService";
import ContentLoading from "../Loading/Loading";
import { goToTop } from "../../utiles/GotoTop";

const ManageTourFiveStep = () => {
  const [submitTracker, setSubmitTracker] = useState(0);
  const [servicesList, setServicesList] = useState([]);

  const ChangeSubmitTracker = () => {
    setSubmitTracker(submitTracker + 1);
  };

  const [error, setError] = useState(null);
  const { stateAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  let params = useParams();
  // const [searchParams, setSearchParams] = useSearchParams();
  // const id = searchParams.get("id");
  // console.log(id);
  const deleteServiceListHandler = (id) => {
    const requestData = {
      id: id,
    };
    const deleteService = async () => {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      try {
        const { data } = await DeleteServiceList(requestData, header);
        //setServicesList(data);
        setSubmitTracker(submitTracker + 1);
        setLoading(false);
        goToTop();
      } catch (error) {
        console.log(error);
        goToTop();
      }
    };
    deleteService();
  };
  useEffect(() => {
    setLoading(true);
    const requestData = {
      PackageId: params.id,
    };
    const ServicesList = async () => {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      try {
        const { data } = await GetServicesList(requestData, header);
        setServicesList(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    ServicesList();
  }, [submitTracker]);

  /*************** formik **************/

  return (
    <TrackVisibility once>
      {({ isVisible }) =>
        isVisible && (
          <div className="animate__animated animate__fadeIn">
            <UpdateTourFormFourthStep
              servicesList={servicesList}
              deleteServiceListHandler={deleteServiceListHandler}
              ChangeSubmitTracker={ChangeSubmitTracker}
              loading={loading}
            />
          </div>
        )
      }
    </TrackVisibility>
  );
};

export default ManageTourFiveStep;
